// extracted by mini-css-extract-plugin
export default {"slideShowControlWrapper":"custom-slideshow-controls-wrapper-module__slideShowControlWrapper--hVXbS"};